<template>
    <md-select id="timeDelay" v-model="selectedTimeDelay">
        <md-option v-for="item in filteredTimeDelayOptions" :key="item.value" :value="item.value">
            {{ item.text }}
        </md-option>
    </md-select>
</template>

<script>
import { TEAM_CUSTOM_ACTION_TIME_DELAY_OPTIONS } from '@/utils/CustomActionConstants';

export default {
    name: 'TimeDelayType',
    props: {
        value: { type: String, default: () => null },
        includePreDelivery: { type: Boolean, default: false },
        limitTimeDelayOptions: { type: Array, default: () => [] }
    },
    data() {
        return {
            selectedTimeDelay: null,
            timeDelayOptions: TEAM_CUSTOM_ACTION_TIME_DELAY_OPTIONS
        };
    },
    computed: {
        filteredTimeDelayOptions() {
            if (this.limitTimeDelayOptions.length) {
                return this.timeDelayOptions.filter((option) => this.limitTimeDelayOptions.includes(option.value));
            }

            if (this.includePreDelivery) {
                return this.timeDelayOptions.filter((option) => option.value !== 'LeadTime');
            }

            return this.timeDelayOptions.filter(
                (option) => option.value !== 'PreDelivery' && option.value !== 'LeadTime'
            );
        }
    },
    watch: {
        value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.selectedTimeDelay = newVal;
            }
        },
        selectedTimeDelay(newVal, oldVal) {
            this.$emit('changed', newVal);
        }
    },
    mounted() {
        this.selectedTimeDelay = this.value;
    }
};
</script>
